import { render } from "./EventSearch.vue?vue&type=template&id=022d48fa"
import script from "./EventSearch.vue?vue&type=script&lang=js"
export * from "./EventSearch.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__